import styled from 'styled-components';

interface IndicatorProps {
  sent: boolean;
}

export const Indicator = styled.div<IndicatorProps>`
  height: 8px;
  width: 8px;
  display: inline-block;
  border-radius: 50%;
  background-color: ${({sent}) => sent ? '#F89406' : '#049CDB'};
`
